module.exports = __webpack_public_path__ + "img/Fifth Third Bank.bb3c9d71.png";